/**
 * Every Repli360 / ApartmentSync selector that paints the vendor-configured
 * accent color (site 3557), grouped by the property it sets. Selectors already
 * handled by name in `apartment-sync-colors.ts` are not repeated here. Most
 * belong to alternate vendor layouts and popups that the widget can switch to
 * without a site deploy, so they are covered up front.
 *
 * The "View Units" popup loads a second stylesheet only when it opens
 * (`getUnitListByFloor`), so its selectors don't appear in the initial
 * widget markup and must be listed here as well.
 */
export const vendorAccentSelectors = {
  background: [
    '#rrac_apartment_details .rrac_listAvailableUnit table tr td a',
    '#rrac_datepickerView .rrac_datepicker_content .leaseNowButton a',
    '#rrac_filterContent .noUi-handle',
    '.apartment_sync_grid_view .blok .bot li:first-child a',
    '.bottom_part_rrac7 .rrac7_contentarea_tab .floorplan_card_area li .card_main .card_main_bottom .card_main_bottomright a',
    '.cortland_mini_filter .filter_finder .filter_finder_item .finder-button',
    '.floor_plan_main_1_3 .floor_plan_table_1_3 table td a.button',
    '.floor_plan_main_1_3 .floor_plan_table_1_3 table td.img_sec span button',
    '.listing_v_build .bottomlist_sec ul li .unit-search-content .unit-cta .reserve a',
    '.repli-advancepopup1 .check-availability__table .check-availability__cell--links a',
    '.repli-advancepopup1 .check-availability__table .check-availability__cell--view-amenities a',
    '.repli-advancepopup1 .check-availability__table .trigger_popup_fricc.check-availability__cell-link',
    '.repli-advancepopup1 .floorplan-modal__button',
    '.rrac-popup #rrac_apartment_details .rrac_listAvailableUnit table tr td span.term_plan_matrix_wrapper .popovers-area .price-matrix .price-matrix-item .term_plan_matrix_Leaseterm_link',
    '.rrac_floorplanDetails #available_units .emptyUnitMessage a',
    '.rrac_floorplanDetails .fp_details_plfull .right_part .btn[type="button"]',
    '.rrac_floorplanDetails .fp_details_plfull .right_part .inn a',
    '.rrac_floorplanDetails .fp_details_plfull .right_part a.btn',
    '.rrac_floorplanDetails .rrac_listAvailableUnit table tr td a',
    '.rrac_modal_container .apt_button a',
    '.rrac_showAllUnit .emptyUnitMessage a',
    '.rrac_showAllUnit .fp_table td a',
    '.rrac_tabSection .tab-content .rrac_FullRow .rrac_appt_btn a',
    '.rrac_tabSection.rracListView_4 .main-wrap .filter-sec .top-level-filter .noUi-handle',
    '.rrac_tabSection.rracListView_4 .main-wrap .navfilterex #rrac_filterContent ul li button',
    '.slideout .slideout__wrap .slideout__footer .slideout__actions .background',
    '.special_avail a',
    '.temSix_field_tabs .page-tabs .availability_filters.fp_tab_newUi_wrap .tabs.floorplan_temp_sixUi .tab-link.current',
    '.temSix_field_tabs .page-tabs .tab-content .content.table_sec table tr th',
    '.temSix_field_tabs .page-tabs .tab-content .floorPlanGrid .floorPlanItem .details1 .availability button',
    '.tooltip-open .ui-dialog .ui-dialog-content .term_plan_matrix_Leaseterm_link',
    '.ui-dialog.fee_dialog .fee-wrapper .unit-leaseing a',
    '.ui-dialog.fee_dialog .ui-dialog-titlebar .ui-dialog-titlebar-close',
  ],
  backgroundHover: [
    '#rrac_filterContent .noUi-handle:focus',
    '.bottom_part_rrac7 .rrac7_contentarea_tab .floorplan_card_area li .card_main .card_main_bottom .card_main_bottomright a:hover',
    '.cortland_mini_filter .filter_finder .filter_finder_item .finder-button:hover',
    '.floor_plan_main_1_3 .floor_plan_table_1_3 table td a.button:hover',
    '.floor_plan_main_1_3 .floor_plan_table_1_3 table td.img_sec span button:hover',
    '.listing_v_build .bottomlist_sec ul li .unit-search-content .unit-cta .reserve a:hover',
    '.repli-advancepopup1 .check-availability a:hover',
    '.repli-advancepopup1 .check-availability__table .trigger_popup_fricc.check-availability__cell-link:hover',
    '.repli-advancepopup1 .floorplan-modal__button:hover',
    '.rrac_floorplanDetails .fp_details_plfull .right_part .btn:hover',
    '.rrac_floorplanDetails .fp_details_plfull .right_part .inn a:hover',
    '.rrac_modal_container .apt_button a:focus',
    '.rrac_modal_container .apt_button a:hover',
    '.rrac_tabSection .tab-content .rrac_FullRow .rrac_appt_btn a:focus',
    '.rrac_tabSection .tab-content .rrac_FullRow .rrac_appt_btn a:hover',
    '.rrac_tabSection.rracListView_4 .main-wrap .phase-rrac-tabs .phase_rrac_tabs_id a:hover',
    '.slideout .slideout__wrap .slideout__footer .slideout__actions .background:hover',
    '.temSix_field_tabs .floorPlanModal .content .floorPlanContent .availableUnitBlock .emptyUnitMessage a:hover',
    '.temSix_field_tabs .floorPlanModal .content .floorPlanContent .availableUnitBlock table tr td a:hover',
    '.temSix_field_tabs .page-tabs .tab-content .content.table_sec table .repli-advancepopup1 .floorplan-modal__links .lazysquare-2d-3d a:hover',
    '.temSix_field_tabs .page-tabs .tab-content .content.table_sec table tr td .avail-cta-wrapper .apply_btn:hover',
    '.top-level-filter .noUi-handle:focus',
    '.top_part_rrac7 .wrapper .top_right_rrac7 .floor_plan_filter_area li .handle-dropmain:hover',
    '.top_part_rrac7 .wrapper .top_right_rrac7 .floor_plan_filter_area li .more-mini-filter:hover',
    '.tooltip-open .ui-dialog .ui-dialog-content .term_plan_matrix_Leaseterm_link:hover',
  ],
  color: [
    '#available_units table tr td.rrac_unit_price span .rrac-price',
    '#rrac_Floorplan_Gallery .rrac_Floorplan_Gallery_Content .rrac_gallery_tab_content .owl-carousel .owl-nav span',
    '#rrac_apartment_details .rrac_listAvailableUnit table .fp_2nd_msg',
    '#rrac_apartment_details .rrac_listAvailableUnit table .fp_3rd_msg',
    '#rrac_apartment_details .rrac_listAvailableUnit table .fp_first_msg',
    '#rrac_apartment_details .rrac_listAvailableUnit table .rrac-price',
    '#rrac_apartment_details .rrac_listAvailableUnit table tr td.rrac_unit_price .fee_details',
    '#rrac_apartment_details .rrac_listAvailableUnit table tr td.rrac_unit_price .unit_price_value',
    '.bottom_part_rrac7 .floorplan_card_area .no-availability h3',
    '.bottom_part_rrac7 .rrac7_contentarea_tab .floorplan_card_area li .card_main .card_main_bottom .card_main_bottomleft span',
    '.bottom_part_rrac7 .rrac7_contentarea_tab .srchCriBtnWrapper .srchCriBtn',
    '.cortland_mini_filter .filter_finder .filter_finder_item .drop_rrac7.check_area button',
    '.cortland_mini_filter .filter_finder .filter_finder_item .drop_rrac7.check_area button:hover',
    '.cortland_mini_filter .filter_finder .filter_finder_item .finder-toggle span',
    '.cortland_mini_filter .filter_finder .filter_finder_item ul.dropdown.check_area .rrac-daterange .ui-datepicker-calendar tr th',
    '.cortland_mini_filter .filter_finder .filter_finder_item ul.dropdown.check_price .reset-price.drop-open',
    '.cortland_mini_filter .filter_finder .filter_finder_item ul.dropdown.check_price .reset-price.drop-open:hover',
    '.fee_details',
    '.overlay.repli-advancepopup1 .popup .content .leftRightContentPop .left-content-pop h2',
    '.repli-advancepopup1 .check-availability .no-availability',
    '.repli-advancepopup1 .check-availability a',
    '.repli-advancepopup1 .check-availability__cell--head',
    '.repli-advancepopup1 .popup .content .right-content-top ul.floor_tab_rrrac7 .tablink',
    '.repli-advancepopup1 .popup .content .right-content-top ul.floor_tab_rrrac7 .tablink:hover',
    '.repli-advancepopup1 .popup .content .right-content-top ul.floor_tab_rrrac7 li.tab_active',
    '.rrac_floorplanDetails .fp_details_plfull .right_part .rrac-price',
    '.rrac_tabSection .tab-content .rrac_FullRow .rrac_appt_det span',
    '.rrac_tabSection.rracListView_4 .main-wrap .filter-sec h2 span',
    '.rrac_tabSection.rracListView_4 .pro-sec .right-sec .decp span',
    '.slideout .slideout__wrap .slideout__body .slideout__row .drop_rrac7 .reset-date',
    '.slideout .slideout__wrap .slideout__body .slideout__row .drop_rrac7 .reset-date:hover',
    '.slideout .slideout__wrap .slideout__body .slideout__row .drop_rrac7 li .button-wrapper .reset-price',
    '.slideout .slideout__wrap .slideout__body .slideout__row .drop_rrac7 li .button-wrapper .reset-price:hover',
    '.slideout .slideout__wrap .slideout__body .slideout__row .drop_rrac7 li .button-wrapper .reset-sqft',
    '.slideout .slideout__wrap .slideout__body .slideout__row .drop_rrac7 li .button-wrapper .reset-sqft:hover',
    '.slideout .slideout__wrap .slideout__body .slideout__row .drop_rrac7.check_area li .reset-bedroom',
    '.slideout .slideout__wrap .slideout__body .slideout__row .drop_rrac7.check_area li .reset-bedroom:hover',
    '.slideout .slideout__wrap .slideout__body .slideout__row .drop_rrac7.check_area li .reset-floor',
    '.slideout .slideout__wrap .slideout__body .slideout__row .drop_rrac7.check_area li .reset-floor:hover',
    '.slideout .slideout__wrap .slideout__body .slideout__row .dropmain',
    '.temSix_field_tabs .floorPlanModal .content .floorPlanContent .availableUnitBlock .emptyUnitMessage a',
    '.temSix_field_tabs .floorPlanModal .content .floorPlanContent .availableUnitBlock table tr td a',
    '.temSix_field_tabs .page-tabs .tab-content .content.table_sec table .repli-advancepopup1 .floorplan-modal__links .lazysquare-2d-3d a',
    '.temSix_field_tabs .page-tabs .tab-content .content.table_sec table tr td .avail-cta-wrapper .apply_btn',
    '.temSix_field_tabs .page-tabs .tab-content .content.table_sec table tr td .floorPlan_Button',
    '.temSix_field_tabs .page-tabs ul.tabs li.current',
    '.top_part_rrac7 .wrapper .top_right_rrac7 .floor_plan_filter_area li .button-wrapper .reset-sqft',
    '.top_part_rrac7 .wrapper .top_right_rrac7 .floor_plan_filter_area li .button-wrapper .reset-sqft:hover',
    '.top_part_rrac7 .wrapper .top_right_rrac7 .floor_plan_filter_area li .check_area button',
    '.top_part_rrac7 .wrapper .top_right_rrac7 .floor_plan_filter_area li .check_area button:hover',
    '.top_part_rrac7 .wrapper .top_right_rrac7 .floor_plan_filter_area li .drop_rrac7 li .text-center.reset-date',
    '.top_part_rrac7 .wrapper .top_right_rrac7 .floor_plan_filter_area li .drop_rrac7 li .text-center.reset-date:hover',
    '.top_part_rrac7 .wrapper .top_right_rrac7 .floor_plan_filter_area li .drop_rrac7 li.drop-open .slider-price-wrapper.drop-open .reset-price.drop-open',
    '.top_part_rrac7 .wrapper .top_right_rrac7 .floor_plan_filter_area li .drop_rrac7 li.drop-open .slider-price-wrapper.drop-open .reset-price.drop-open:hover',
    '.tooltip-open .ui-dialog .price-matrix-sub strong',
    '.ui-dialog.fee_dialog .fee-wrapper .fee-subwrapper .fee-sub .fee-calc .fee-calc-sub',
    '.unit-rrac-price',
  ],
  border: [
    '.repli-advancepopup1 .check-availability .no-availability',
    '.repli-advancepopup1 .check-availability a',
    '.repli-advancepopup1 .floorplan-modal-gallery .floorplan-single-images #sync2 .owl-item.active.current',
    '.temSix_field_tabs .floorPlanModal .content .floorPlanContent .availableUnitBlock .emptyUnitMessage a',
    '.temSix_field_tabs .floorPlanModal .content .floorPlanContent .availableUnitBlock table tr td a',
    '.temSix_field_tabs .page-tabs .tab-content .content.table_sec table .repli-advancepopup1 .floorplan-modal__links .lazysquare-2d-3d a',
    '.temSix_field_tabs .page-tabs .tab-content .content.table_sec table tr td .avail-cta-wrapper .apply_btn',
  ],
  underline: [
    '.repli-advancepopup1 .popup .content .right-content-top ul.floor_tab_rrrac7 li.tab_active',
    '.temSix_field_tabs .page-tabs .availability_filters .bed_pagination_dropdown',
    '.temSix_field_tabs .page-tabs .availability_filters .floor_pagination_dropdown',
    '.temSix_field_tabs .page-tabs .availability_filters .floorsFilters li input:checked+label',
    '.temSix_field_tabs .page-tabs .page-tabs-container .availability_filters .Order_Filter_title',
    '.temSix_field_tabs .page-tabs .page-tabs-container .availability_filters ul.OrdersFilters li',
  ],
  fill: [
    '#rrac_apartment_details .rrac_listAvailableUnit table tr td span.term_plan_matrix_wrapper a svg',
    '.temSix_field_tabs .page-tabs .page-tabs-container .availability_filters ul.OrdersFilters li span.active svg',
  ],
  scrollbar: [
    '.repli-advancepopup1 .check-availability__table .check-availability__cell--view-amenities .popovers-area.special',
    '.rrac-popup #rrac_apartment_details .rrac_listAvailableUnit table tr td .entrata_unitwise_amenity_wrap .popovers-area',
  ],
};
